import { useState, useEffect, useRef } from 'react';
import { useUI }       from '../../context/UIContext';
import { useCurrency } from '../../context/CurrencyContext';
import { getProducts } from '../../lib/api';

import { BASE_URL, imgSrc } from '../../lib/env';
const BASE = BASE_URL;
// const BASE   = 'http://localhost/CODIZN-full-project%20(2)/codizn/backend';
// const imgSrc = (url) => !url?null:url.startsWith('http')?url:`${BASE}${url}`;

export default function SearchOverlay() {
  const { searchOpen, closeSearch, openQV } = useUI();
  const { fmt } = useCurrency();
  const [query, setQuery]       = useState('');
  const [products, setProducts] = useState([]);
  const [results,  setResults]  = useState([]);
  const inputRef = useRef(null);

  useEffect(() => {
    if (searchOpen) {
      getProducts().then(setProducts).catch(()=>{});
      setTimeout(() => inputRef.current?.focus(), 80);
    } else { setQuery(''); setResults([]); }
  }, [searchOpen]);

  useEffect(() => {
    if (!query.trim()) { setResults([]); return; }
    const q = query.toLowerCase();
    setResults(products.filter(p =>
      p.name.toLowerCase().includes(q) ||
      p.brand.toLowerCase().includes(q) ||
      (p.category||'').toLowerCase().includes(q)
    ).slice(0, 8));
  }, [query, products]);

  useEffect(() => {
    const fn = (e) => { if (e.key === 'Escape') closeSearch(); };
    document.addEventListener('keydown', fn);
    return () => document.removeEventListener('keydown', fn);
  }, [closeSearch]);

  if (!searchOpen) return null;

  return (
    <div className="animate-fade-in" style={{ position:'fixed', inset:0, background:'#fff', zIndex:200, display:'flex', flexDirection:'column' }}>

      {/* Search bar */}
      <div style={{ display:'flex', alignItems:'center', padding:'18px 48px', borderBottom:'1px solid var(--grey)', gap:16 }}>
        <svg width={20} height={20} fill="none" stroke="var(--grey-mid)" strokeWidth={1.5} viewBox="0 0 24 24" style={{ flexShrink:0 }}>
          <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/>
        </svg>
        <input ref={inputRef} value={query} onChange={e=>setQuery(e.target.value)} placeholder="Search brands, styles, categories…"
          style={{ flex:1, fontSize:'clamp(18px,3vw,26px)', fontFamily:'var(--font-display)', fontWeight:300, color:'var(--dark)', border:'none', outline:'none', background:'transparent', letterSpacing:'-0.01em' }} />
        <button onClick={closeSearch} style={{ background:'none', border:'none', cursor:'pointer', color:'var(--grey-mid)', display:'flex', alignItems:'center' }}>
          <svg width={20} height={20} fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24"><path d="M18 6L6 18M6 6l12 12"/></svg>
        </button>
      </div>

      {/* Results */}
      <div style={{ flex:1, overflowY:'auto', padding:'32px 48px' }}>
        {!query && (
          <p style={{ fontSize:11, color:'var(--grey)', letterSpacing:'0.2em', textTransform:'uppercase', textAlign:'center', paddingTop:60 }}>
            Start typing to search the collection
          </p>
        )}
        {query && results.length === 0 && (
          <p style={{ fontSize:14, color:'var(--grey-mid)', textAlign:'center', paddingTop:60 }}>
            No results for "<strong>{query}</strong>"
          </p>
        )}
        {results.length > 0 && (
          <>
            <p style={{ fontSize:11, color:'var(--grey-mid)', letterSpacing:'0.1em', marginBottom:24 }}>{results.length} result{results.length!==1?'s':''}</p>
            <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(150px,1fr))', gap:24 }}>
              {results.map(p => (
                <button key={p.id} onClick={()=>{ openQV(p); closeSearch(); }}
                  style={{ textAlign:'left', background:'none', border:'none', cursor:'pointer', padding:0 }}>
                  <div className="img-zoom-wrap" style={{ aspectRatio:'1', background:'var(--cream)', marginBottom:10, overflow:'hidden' }}>
                    {p.img && <img src={imgSrc(p.img)} alt={p.name} className="img-zoom" style={{ width:'100%', height:'100%', objectFit:'cover', mixBlendMode:'multiply' }} />}
                  </div>
                  <div style={{ fontSize:10, color:'var(--grey-mid)', letterSpacing:'0.15em', textTransform:'uppercase', marginBottom:3 }}>{p.brand}</div>
                  <div style={{ fontSize:13, fontWeight:500, color:'var(--dark)', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{p.name}</div>
                  <div style={{ fontSize:12, color:'var(--dark)', marginTop:3 }}>{fmt(p.price)}</div>
                </button>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}